// extracted by mini-css-extract-plugin
export default {"text-color":"#000000","textColor":"#000000","color-grimace-purple":"#8735EA","colorGrimacePurple":"#8735EA","productCard":"_18xWY"};